import { storableError } from '../../util/errors';
import { deleteCurrentUser } from '../../util/api';
import { logout } from '../../ducks/auth.duck';

// ================ Action types ================ //

export const DELETE_ACCOUNT_REQUEST = 'app/ManageAccountPage/DELETE_ACCOUNT_REQUEST';
export const DELETE_ACCOUNT_SUCCESS = 'app/ManageAccountPage/DELETE_ACCOUNT_SUCCESS';
export const DELETE_ACCOUNT_ERROR = 'app/ManageAccountPage/DELETE_ACCOUNT_ERROR';
export const DELETE_ACCOUNT_CLEAR = 'app/ManageAccountPage/DELETE_ACCOUNT_CLEAR';

// ================ Reducer ================ //

const initialState = {
  deleteAccountInProgress: false,
  deleteAccountError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case DELETE_ACCOUNT_REQUEST:
      return { ...state, deleteAccountInProgress: true, deleteAccountError: null };
    case DELETE_ACCOUNT_SUCCESS:
      return { ...state, deleteAccountInProgress: false };
    case DELETE_ACCOUNT_ERROR:
      return { ...state, deleteAccountInProgress: false, deleteAccountError: payload };
    case DELETE_ACCOUNT_CLEAR:
      return { ...initialState };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const deleteAccountRequest = () => ({ type: DELETE_ACCOUNT_REQUEST });
export const deleteAccountSuccess = () => ({ type: DELETE_ACCOUNT_SUCCESS });
export const deleteAccountError = e => ({
  type: DELETE_ACCOUNT_ERROR,
  error: true,
  payload: e,
});
export const deleteAccountClear = () => ({ type: DELETE_ACCOUNT_CLEAR });

// ================ Thunks ================ //

// Permanently deletes the current user. This goes through the local server
// (server/api/delete-account.js): current_user/delete needs a trusted token,
// so the browser SDK's own call always fails with 403. A 403 from the server
// means a wrong password. On success the session is logged out; the SDK
// clears the stored token even if revoking the now-invalid token fails.
export const deleteAccount = params => (dispatch, getState, sdk) => {
  dispatch(deleteAccountRequest());
  const { currentPassword } = params;

  return deleteCurrentUser({ currentPassword })
    .then(() => {
      dispatch(deleteAccountSuccess());
      return dispatch(logout());
    })
    .catch(e => {
      dispatch(deleteAccountError(storableError(e)));
      throw e;
    });
};
